// extracted by mini-css-extract-plugin
module.exports = {"searchCollapse":"_1AWG8099dTphrGA6_jb-G7"};